// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".homepage-books[data-v-56392c79]{z-index:-1}.sticker[data-v-56392c79]{position:absolute}.zeker-slagen[data-v-56392c79]{left:15%;top:-12%}.examenidiom[data-v-56392c79]{right:13%;top:-9%}.examenbundel[data-v-56392c79]{bottom:10%;left:5%}.samengevat[data-v-56392c79]{bottom:16%;right:7%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
